import {MediaPlayer, MediaProvider} from "@vidstack/react";
import {defaultLayoutIcons, DefaultVideoLayout} from "@vidstack/react/player/layouts/default";
import React from "react";
import VideoItemActionButtons from "./VideoItemActionButtons";
import VideoItemHeader from "./VideoItemHeader";

const VideoItem = ({video}) => {
	if (video) {
		return (
			<div className="max-w-screen-sm mx-auto">
				<div className="flex items-end gap-x-4">
					<div className="min-w-0 flex-1">
						<VideoItemHeader video={video} />

						<MediaPlayer
							title={video.Attachment.filename} src={video.Attachment.direct_url}
							className="w-full h-full"
							autoplay muted loop playsinline
						>
							<MediaProvider className="w-full h-full"/>
							<DefaultVideoLayout icons={defaultLayoutIcons}/>
						</MediaPlayer>
					</div>

					<div className="flex-grow-0 flex-shrink-0">
						<VideoItemActionButtons video={video} isVertical={true}/>
					</div>
				</div>
			</div>
		);
	}
}

export default VideoItem;